import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "children", "Render"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * @Author: wangshengqiang
 * @Date: 2021-06-30 16:50:18
 * @LastEditTime: 2021-09-28 17:37:29
 * @LastEditors: wangshengqiang
 * @Description: 投保结果组件
 */
import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Toast } from 'zarm';
import { queryPolicyInfo } from '@/services/order.js';
import { dispatch, getState } from '@/store';
import { getQueryParam } from '@/utils/tool';
import { POLICY_INFO } from '@/constants';
const Result = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    children,
    Render
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const cls = classnames({
    'components-insure-result-render': true,
    [className]: !!className
  });
  useEffect(() => {
    let timer; // 获取订单号, 并查询保单详情放入store

    const fn = async () => {
      const queryParam = getQueryParam() || {};
      const orderNo = queryParam.orderNo || getState('orderNo');

      if (!orderNo) {
        return;
      }

      const data = _objectSpread({}, queryParam); // const opts = { method: 'POST', data };


      const res = await queryPolicyInfo(data);
      const {
        code,
        message,
        result = {}
      } = res;

      if (Number(code)) {
        Toast.show(message);
      } else {
        dispatch(POLICY_INFO, result);
      }
    };

    const loop = async () => {
      await fn();
      const policyInfo = getState(POLICY_INFO) || {};
      const {
        issueStatus
      } = policyInfo;
      const list = [undefined, 'processing'];
      const included = list.includes(issueStatus);

      if (included) {
        timer = setTimeout(loop, 5000);
        issueStatus === 'processing' && Toast.show('订单处理中...');
      }
    };

    loop();
    return () => clearTimeout(timer);
  }, []);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
export default Result;